const Masonry = require("masonry-layout");

const commentsBlock = document.querySelector('.comments-list')

if (commentsBlock) {
    new Masonry(commentsBlock, {
        columnWidth: '.comments-list__sizer',
        itemSelector: '.comments-list__item',
        percentPosition: true,
        /*
        respositive: {
            0: {
                columns: 1,
                gap: 20,
            },
            700: {
                columns: 2,
                gap: 20,
            },
            1000: {
                columns: 3,
                gap: 20,
            },
        }*/
    })
}